export const CHART_COLORS = {
  primary:   '#6366f1',
  secondary: '#8b5cf6',
  success:   '#22c55e',
  danger:    '#ef4444',
  warning:   '#f59e0b',
  info:      '#3b82f6',
  muted:     '#94a3b8',
};

export const CHART_PALETTE = [
  '#6366f1', '#22c55e', '#f59e0b', '#ef4444',
  '#8b5cf6', '#3b82f6', '#ec4899', '#14b8a6',
  '#f97316', '#06b6d4', '#84cc16', '#a855f7'
];

export const STATUS_COLORS = {
  active:     '#22c55e',
  trialing:   '#3b82f6',
  canceled:   '#ef4444',
  past_due:   '#f59e0b',
  incomplete: '#94a3b8',
};

export const CHART_THEME = {
  grid: { stroke: '#e2e8f0', strokeDasharray: '3 3' },
  axis: { stroke: '#cbd5e1', fontSize: 11, fill: '#64748b' },
  tooltip: {
    bg: '#1e293b',
    text: '#f8fafc',
    border: 'none',
    borderRadius: 8,
  }
};
